import { render } from "./FamilyEventHomeView.vue?vue&type=template&id=f906648a&ts=true"
import script from "./FamilyEventHomeView.vue?vue&type=script&lang=ts"
export * from "./FamilyEventHomeView.vue?vue&type=script&lang=ts"

import "./FamilyEventHomeView.vue?vue&type=style&index=0&id=f906648a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__